import type { IdName, ValueName, CheckBoxValue } from '@/interfaces/global'

// 燃料
export const FUELS: IdName[] = [
  { id: 'fuels_1', name: 'ガソリン' },
  { id: 'fuels_2', name: '軽油' },
  { id: 'fuels_3', name: '電気自動車(EV)' },
  { id: 'fuels_4', name: 'ハイブリッド' },
  { id: 'fuels_5', name: 'プラグイン ハイブリッド' },
  { id: 'fuels_6', name: 'LPG車' },
  { id: 'fuels_7', name: 'CNG車' },
  { id: 'fuels_8', name: '水素' },
]

// 駆動
export const DRAIVE_TYPES: Map<string, string[]> = new Map([
  ['二輪', ['FF', 'FR', 'RR', 'MR']],
  ['四輪', ['4WD', '6WD']],
])

// その他
export const OTHER_OPTIONS: IdName[] = [
  { id: 'others_2', name: '限定／ 特別仕様車' },
]

// 価格(単位・万円)
export const CAR_PRICE: number[] = [
  -1, 100, 150, 200, 250, 300, 350, 400, 450, 500, 600, 700, 800, 900, 1000,
  1500, 2000, 2500, 3000,
]

export const BODY_TYPES: ValueName[] = [
  { value: 0, name: '指定なし' },
  { value: 1, name: 'クーペ' },
  { value: 2, name: 'コンパクトカー&ハッチバック' },
  { value: 3, name: 'ミニバン・ワンボックス' },
  { value: 4, name: 'オープンカー' },
  { value: 5, name: 'ピックアップトラック' },
  { value: 6, name: 'セダン' },
  { value: 7, name: 'SUVクロカン' },
  { value: 8, name: 'ワゴン' },
  { value: 9, name: '軽RV系' },
  { value: 10, name: '軽自動車' },
  { value: 11, name: 'ハードトップ' },
  { value: 12, name: 'ボンネットバン' },
  { value: 13, name: 'キャブバン' },
  { value: 14, name: '軽キャブバン' },
  { value: 15, name: 'トラック' },
  { value: 16, name: '軽トラック' },
  { value: 17, name: 'バス' },
]

// ミッション
export const MISSION_TYPES: Map<string, string[]> = new Map([
  ['MT', ['MT']],
  ['MT以外', ['AT', 'CVT']],
])

// 全長
export const CAR_LENGTH: CheckBoxValue[] = [
  {
    name: '3,400mm以下（軽自動車規格の最大）',
    value: { max: '3400' },
  },
  {
    name: '3,401mm〜4,000mm',
    value: { min: '3401', max: '4000' },
  },
  {
    name: '4,001mm〜4,700mm（4、5ナンバー規格の最大）',
    value: { min: '4001', max: '4700' },
  },
  {
    name: '4,701mm〜5,000mm',
    value: { min: '4701', max: '5000' },
  },
  {
    name: '5,001mm以上',
    value: { min: '5001' },
  },
]

// 全幅
export const CAR_WIDTH: CheckBoxValue[] = [
  {
    name: '1,480mm以下（軽自動車規格の最大）',
    value: { max: '1480' },
  },
  {
    name: '1,481mm〜1,700mm（4、5ナンバー規格の最大）',
    value: { min: '1481', max: '1700' },
  },
  {
    name: '1,701mm〜1,850mm',
    value: { min: '1701', max: '1850' },
  },
  {
    name: '1,851mm〜1,900mm',
    value: { min: '1851', max: '1900' },
  },
  {
    name: '1,901mm以上',
    value: { min: '1901' },
  },
]

// 全高
export const CAR_HEIGHT: CheckBoxValue[] = [
  {
    name: '1,550mm以下',
    value: { max: '1550' },
  },
  {
    name: '1,551mm〜2,000mm（軽自動車、5ナンバー規格の最大）',
    value: { min: '1551', max: '2000' },
  },
  {
    name: '2,001mm〜2,100mm',
    value: { min: '2001', max: '2100' },
  },
  {
    name: '2,101mm以上',
    value: { min: '2101' },
  },
]

// 車両重量
export const CAR_WEIGHT: CheckBoxValue[] = [
  {
    name: '1,600kg以下',
    value: { max: '1600' },
  },
  {
    name: '1,601kg〜2,000kg',
    value: { min: '1601', max: '2000' },
  },
  {
    name: '2,001kg〜2,500kg',
    value: { min: '2001', max: '2500' },
  },
  {
    name: '2,501kg以上',
    value: { min: '2501' },
  },
]
